var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"paintBord",staticClass:"paint-bord"},[_c('canvas',{ref:"paintBordCnv",on:{"mousedown":function($event){return _vm.startPrint($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }